<div class="h-full flex flex-col justify-start items-center overflow-hidden">

    @if (updatingPersonalInformation() || updatingNotificationPreferences()) {
    <atom-loading-overlay></atom-loading-overlay>
    } @else {
    <form (submit)="$event.preventDefault()"
        class="mx-autoh-full flex flex-col justify-start items-center overflow-y-auto scrollbar-transparent w-full divide-y divide-zinc-200 dark:divide-zinc-800">
        <div class="space-y-12 p-5">


            <!-- Personal Information section -->
            <div
                class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-zinc-500/10 dark:border-zinc-800 pb-12 md:grid-cols-3">
                <div>
                    <h2 class="text-base/7 font-semibold text-primary">Personal Information</h2>
                    <p class="mt-1 text-sm/6 text-gray-400">Let us know who you are and where we can send important
                        updates.</p>
                </div>

                <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">


                    <div class="col-span-full">
                        <label for="photo" class="block text-sm/6 font-medium text-primary">Profile Photo
                            @if (!currentUserService.hasProfilePicture()) {
                            <span class="text-xs italic text-orange-400 font-normal">Required</span>
                            }
                        </label>
                        <div class="mt-2 flex items-center gap-x-3">
                            @if (profilePhoto()) {
                            <img [src]="imageService.getImageSource(profilePhoto(), 'gallery')" alt=""
                                class="size-16 shrink-0 rounded-full bg-gray-700 outline-1 -outline-offset-1 outline-white/10" />
                            } @else {
                            <svg viewBox="0 0 24 24" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="size-16 text-gray-500">
                                <path
                                    d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                            }
                            <input #fileInput type="file" accept="image/*" class="hidden"
                                (change)="selectFile($event)" />
                            <button type="button" (click)="fileInput.click()"
                                class="text-primary secondary-button">Change</button>
                        </div>
                    </div>


                    <div class="sm:col-span-3">
                        <label for="first-name" class="block text-sm/6 font-medium text-primary">First name
                            @if (personalInformationModel() && personalInformationModel().firstName === '') {
                            <span class="text-xs italic text-orange-400 font-normal">Required</span>
                            }
                        </label>
                        <div class="mt-2">
                            <input [formField]="personalInformationForm.firstName" id="first-name" type="text"
                                autocomplete="given-name" class="input-primary text-primary" />
                        </div>
                    </div>
                    <div class="sm:col-span-3">
                        <label for="last-name" class="block text-sm/6 font-medium text-primary">Last name
                            <!-- @if (!currentUserService.shoutUser.value.lastName) {
                            <span class="text-xs italic text-orange-400 font-normal">Required</span>
                            } -->
                        </label>
                        <div class="mt-2">
                            <input [formField]="personalInformationForm.lastName" id="last-name" type="text"
                                autocomplete="family-name" class="input-primary text-primary" />
                        </div>
                    </div>

                    <div class="sm:col-span-3">
                        <label for="job-position" class="block text-sm/6 font-medium text-primary">Your
                            role/position</label>
                        <div class="mt-2">
                            <input [formField]="personalInformationForm.jobPosition" id="job-position" type="text"
                                autocomplete="job-position" class="input-primary text-primary" />
                        </div>
                    </div>

                    <div class="sm:col-span-3">
                        <label for="email" class="block text-sm/6 font-medium text-primary">Email address</label>
                        <div class="mt-2">
                            <input [formField]="personalInformationForm.email" id="email" type="email"
                                autocomplete="email"
                                class="input-primary text-primary disabled:bg-white/10 disabled:text-primary/50 disabled:cursor-not-allowed" />
                        </div>
                        @if (canEditOwnEmail()) {
                        <div
                            class="mt-2 rounded-md bg-yellow-50 p-4 dark:bg-yellow-500/10 dark:outline dark:outline-yellow-500/20">
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        class="size-5 text-yellow-400">
                                        <path fill-rule="evenodd"
                                            d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                                            clip-rule="evenodd" />
                                    </svg>

                                </div>
                                <div class="ml-3 flex-1 md:flex md:justify-between">
                                    @if (emailJustUpdated()) {
                                    <p class="text-sm text-yellow-700 dark:text-yellow-300">
                                        Email saved. Optionally send a password reset to the new address.
                                    </p>
                                    } @else {
                                    <p class="text-sm text-yellow-700 dark:text-yellow-300">
                                        <b>Caution: </b>
                                        Email address will only be updated when "Update email" is clicked specifically.
                                    </p>
                                    }
                                    @if (emailJustUpdated()) {
                                    <p class="mt-3 text-sm md:mt-0 md:ml-6">
                                        <button type="button" (click)="sendPasswordReset()"
                                            [disabled]="!canSendPasswordReset()" class="font-medium whitespace-nowrap text-yellow-700 hover:text-yellow-600
                                            dark:text-yellow-300 dark:hover:text-yellow-200">
                                            {{ passwordResetSendingState() ? 'Sending…' : 'Reset password' }}
                                            <span aria-hidden="true"> &rarr;</span>
                                        </button>
                                    </p>
                                    } @else {
                                    <p class="mt-3 text-sm md:mt-0 md:ml-6">
                                        <button type="button" (click)="saveEmail()" [disabled]="!canSaveEmail()" class="font-medium whitespace-nowrap text-yellow-700 hover:text-yellow-600
                                        dark:text-yellow-300 dark:hover:text-yellow-200">
                                            {{ emailSavingState() ? 'Updating…' : 'Update email' }}
                                            <span aria-hidden="true"> &rarr;</span>
                                        </button>
                                    </p>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                    </div>

                    <div class="col-span-full">
                        <label for="email" class="block text-sm/6 font-medium text-primary">
                            Mobile Number
                            @if (personalInformationModel() && personalInformationModel().mobile === '' &&
                            !verifySending()) {
                            <span class="text-xs italic text-orange-400 font-normal">Verification Required</span>
                            }
                        </label>
                        <div class="mt-1 flex flex-row items-center gap-x-2">
                            <input id="mobile" [formField]="personalInformationForm.mobile" autocomplete="mobile"
                                type="tel"
                                class="flex-1 block w-full input-primary text-primary disabled:bg-white/10 disabled:text-primary/50 disabled:cursor-not-allowed">
                            @if (personalInformationModel() && personalInformationModel().mobileVerified === false &&
                            !verifySending()) {
                            <button type="button" (click)="verifyMobile()"
                                class="rounded-full bg-primary px-2.5 py-1 text-xs font-semibold text-white hover:bg-primary/85 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">Verify</button>
                            } @else if (verifySending()) {
                            <div class="flex items-center justify-center w-8 h-8">
                                <svg aria-hidden="true"
                                    class="mx-auto w-4 h-4 text-gray-200 animate-spin dark:text-gray-500 fill-primary"
                                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor" />
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill" />
                                </svg>
                            </div>
                            } @else if (personalInformationModel() && personalInformationModel().mobile !== '' &&
                            !verifySending()) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-green-500">
                                <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                                <path d="m9 11 3 3L22 4" />
                            </svg>
                            }
                        </div>
                        @if (personalInformationModel() && personalInformationModel().mobile === '' && !verifySending())
                        {
                        <p class="mt-1 text-xs italic text-gray-400">
                            Please verify your mobile number to continue.
                        </p>
                        }
                    </div>

                    <div class="col-span-full mt-6 flex items-center justify-end gap-x-6 w-full">
                        <button type="button" (click)="saveChanges()" class="primary-button">Save</button>
                    </div>
                </div>
            </div>
            <!-- Personal Information section  END-->


            <!-- Notifications section -->
            @if (showNotificationPreferences()) {
            <div
                class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-zinc-500/10 dark:border-zinc-800 pb-12 md:grid-cols-3">
                <div>
                    <h2 class="text-base/7 font-semibold text-primary">Notifications</h2>
                    <p class="mt-1 text-sm/6 text-gray-400">We'll always let you know about important changes, but you
                        pick what else you want to hear about.</p>
                </div>

                <div class="space-y-10 md:col-span-2">
                    <fieldset>
                        <legend class="text-sm/6 font-semibold text-primary">By email</legend>
                        <div class="mt-6 space-y-6">
                            @for (notification of notifications; track notification.type) {
                            <div class="flex gap-3">
                                <div class="flex h-6 shrink-0 items-center">
                                    <div class="group grid size-4 grid-cols-1">
                                        <input id="comments" type="checkbox" name="comments"
                                            [checked]="notification.checked" (click)="toggleNotification($index)"
                                            aria-describedby="comments-description"
                                            class="col-start-1 row-start-1 appearance-none rounded border border-white/10 bg-white/5 checked:border-primary checked:bg-primary indeterminate:border-primary indeterminate:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-white/5 disabled:bg-white/10 disabled:checked:bg-white/10 forced-colors:appearance-auto" />
                                        <svg viewBox="0 0 14 14" fill="none"
                                            class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-white/25">
                                            <path d="M3 8L6 11L11 3.5" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="opacity-0 group-has-[:checked]:opacity-100" />
                                            <path d="M3 7H11" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="opacity-0 group-has-[:indeterminate]:opacity-100" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="text-sm/6">
                                    <label for="comments" class="font-medium text-primary">{{ notification.title
                                        }}</label>
                                    <p id="comments-description" class="text-gray-400">{{ notification.description }}
                                    </p>
                                </div>
                            </div>
                            }
                        </div>
                    </fieldset>

                </div>

                <div class="mt-6 flex items-center justify-end gap-x-6 w-full col-span-full">
                    <button type="button" (click)="saveChanges()" class="primary-button">Save</button>
                </div>
            </div>
            }
            <!-- Notifications section  END-->

            <!-- Preferences section -->
            <div
                class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-zinc-500/10 dark:border-zinc-800 pb-12 md:grid-cols-3">
                <div>
                    <h2 class="text-base/7 font-semibold text-primary">Preferences</h2>
                    <p class="mt-1 text-sm/6 text-gray-400">Customise your SHOUT experience.</p>
                </div>

                <div class="space-y-10 md:col-span-2">
                    <div class="flex items-center justify-between">
                        <span class="flex grow flex-col">
                            <label id="availability-label"
                                class="text-sm/6 font-medium text-gray-900 dark:text-white">Toggle Light/Dark
                                Mode</label>
                            <span id="availability-description" class="text-sm text-gray-500 dark:text-gray-400">You're
                                using <i class="italic">{{ isDarkMode() ? 'Dark' : 'Light' }}</i> mode.</span>
                        </span>
                        <div
                            class="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 inset-ring inset-ring-gray-900/5 outline-offset-2 outline-indigo-600 transition-colors duration-200 ease-in-out has-checked:bg-indigo-600 has-focus-visible:outline-2 dark:bg-white/5 dark:inset-ring-white/10 dark:outline-indigo-500 dark:has-checked:bg-indigo-500">
                            <span
                                class="relative size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5">
                                <span aria-hidden="true"
                                    class="absolute inset-0 flex size-full items-center justify-center opacity-100 transition-opacity duration-200 ease-in group-has-checked:opacity-0 group-has-checked:duration-100 group-has-checked:ease-out">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-3 text-gray-400 dark:text-gray-600">
                                        <circle cx="12" cy="12" r="4" />
                                        <path d="M12 2v2" />
                                        <path d="M12 20v2" />
                                        <path d="m4.93 4.93 1.41 1.41" />
                                        <path d="m17.66 17.66 1.41 1.41" />
                                        <path d="M2 12h2" />
                                        <path d="M20 12h2" />
                                        <path d="m6.34 17.66-1.41 1.41" />
                                        <path d="m19.07 4.93-1.41 1.41" />
                                    </svg>
                                </span>
                                <span aria-hidden="true"
                                    class="absolute inset-0 flex size-full items-center justify-center opacity-0 transition-opacity duration-100 ease-out group-has-checked:opacity-100 group-has-checked:duration-200 group-has-checked:ease-in">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-3 text-indigo-600 dark:text-indigo-500">
                                        <path
                                            d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401" />
                                    </svg>
                                </span>
                            </span>
                            <input type="checkbox" name="setting" aria-label="Toggle dark mode" [checked]="isDarkMode()"
                                (change)="toggleDarkMode()"
                                class="absolute inset-0 size-full appearance-none focus:outline-hidden" />
                        </div>
                    </div>

                </div>
            </div>
            <!-- Preferences section - END -->



            <div
                class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-zinc-500/10 dark:border-zinc-800 pb-12 md:grid-cols-3">
                <div>
                    <h2 class="text-base/7 font-semibold text-primary">Account</h2>
                    <p class="mt-1 text-sm/6 text-gray-400">Logout, or close account.</p>
                </div>

                <div class="space-y-10 md:col-span-2">

                    @if (currentUserService.isImpersonating() || currentUserService.impersonationSession()) {
                    <div class="flex flex-row items-center justify-between">

                        <div class="text-sm/6">
                            <label for="comments" class="font-medium text-primary">Impersonate</label>
                            <p id="comments-description" class="text-gray-400">You are impersonating {{
                                currentUserService.impersonationSession()?.targetDisplayName ||
                                personalInformationModel().firstName }}.</p>
                        </div>

                        <div class="flex shrink-0 items-center">
                            <div class="group grid grid-cols-1">
                                <button type="button" (click)="exitImpersonation(); $event.preventDefault()"
                                    class="inline-flex items-center gap-x-1.5 rounded-md bg-primary px-2.5 py-1.5 text-sm font-semibold text-white hover:bg-primary/85 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
                                    Exit Impersonation
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="-mr-0.5 size-5">
                                        <path d="m16 17 5-5-5-5" />
                                        <path d="M21 12H9" />
                                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    }


                    <div class="flex flex-row items-center justify-between">

                        <div class="text-sm/6">
                            <label for="comments" class="font-medium text-primary">Logout</label>
                            <p id="comments-description" class="text-gray-400">Logout of your account.</p>
                        </div>

                        <div class="flex shrink-0 items-center">
                            <div class="group grid grid-cols-1">
                                <button type="button" (click)="logout()"
                                    class="inline-flex items-center gap-x-1.5 rounded-md bg-primary px-2.5 py-1.5 text-sm font-semibold text-white hover:bg-primary/85 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
                                    Logout
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="-mr-0.5 size-5">
                                        <path d="m16 17 5-5-5-5" />
                                        <path d="M21 12H9" />
                                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>


                    <div class="flex flex-row items-center justify-between">
                        <div class="text-sm/6">
                            <label for="comments" class="font-medium text-primary">Close Account</label>
                            <p id="comments-description" class="text-gray-400">Close account permanently.</p>
                        </div>

                        <div class="flex h-6 shrink-0 items-center">
                            <div class="group grid grid-cols-1">
                                <button type="button"
                                    class="inline-flex items-center gap-x-1.5 rounded-md bg-red-500 px-2.5 py-1.5 text-sm font-semibold text-white hover:bg-red-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500">
                                    Close Account
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="-mr-0.5 size-5">
                                        <path d="m16 17 5-5-5-5" />
                                        <path d="M21 12H9" />
                                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


        </div>


    </form>
    }


</div>